<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <form class="build-scan-report-container" [formGroup]="buildingScanForm">
    <ion-row>
      <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
        <div class="form-group form-group-lg no-margin">
          <label class="date-label">{{ CONSTS.DATE_LABEL }} </label>
        </div>
        <app-form-date-picker
          formControlName="date"
          [customClass]="'report-date-picker'"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [icon]="IMAGES.CALENDAR"
        ></app-form-date-picker>
      </ion-col>
      <ion-col
        size="12"
        size-sm="6"
        size-md="6"
        size-lg="6"
        size-xl="12"
        class="custom-row"
      >
        <app-form-select
          formControlName="routes"
          [label]="CONSTS.ROUTE_LABEL"
          [options]="routes"
          [customClass]="'scan-type-dropdown report-select'"
        ></app-form-select>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"> </app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
